<div class="user-request-modal-body-text">
    <p>{{'add_comment_to_mood_placeholder' | translate}}</p>
    <em>{{'add_comment_informations_share_team' | translate}}</em>
</div>

<form class="moodpickers-wrapper">
    @if(item?.comment?.body){
        <button class="delete-comment-button" type="button" aria-label="delete comment" 
                (click)="deleteComment()">
            <i class="fa fa-times"></i>
        </button>
    }

    <textarea class="form-control mood-request-input" id="{{ item.id }}" name="comment" rows="7"
              [formControl]='moodCommentCtrl'
              [attr.placeholder]=" 'add_comment_placeholder' | translate "></textarea>

    <tm-mood-pickers (onElement)="fromMoodPicker($event)"></tm-mood-pickers>
</form>

<div class="disclaimer-area">
    <p>
        <small>{{'add_comment_informations_disclaimer' | translate}} <a href="/{{teamId}}/codeofconduct" target="_blank">{{codeOfConductLabel}}</a></small>
    </p>
</div>